export const stringsKey = "ExcelFileUpload";
export const englishStrings = {
	numberOfRecordsText: "Number of Records",
	noFileSelectedText: "Select an Excel file (.xls, .csv, .xlsx)",
	uploadedLabel: "Uploaded",
	addedLabel: "Added",
	uploadFileToolTip: "Upload excel/csv file",
	fileTypeErrorText: "Only .xlsx, .xls and .csv files allowed",
	uploadErrorSnackbarMessage: "Error uploading file.",
	fileUploadValidationMessage: "The file upload field is required",
	clickText: "Click",
	hereText: "here",
	excelTemplateManualText: "to download a template Excel file",
};
